import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import chatBotImage from "../../Artifacts/manpower/chatbot AI.gif";
import dealerSummaryImage from "../../Artifacts/manpower/dealerSummary.gif";
import AiChatBotModal from "../Modals/AiChatBot";
import SummaryModal from "../Modals/DealerReviewSummary/SummaryModal";

import { axInst2, axInst } from "../../Components/Login/Service";

const FloatingButtonWithModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [showAiChatBotModal, setShowAiChatBotModal] = useState(false);
  const [data, setData] = useState(null);

  // Summary Modal
  const handleModal = async (status) => {
    setShowSummaryModal(status);

    // Close floating menu when modal opens/closes
    if (!status) {
      setIsOpen(false);
    }

    try {
      await axInst.post(`user-logs`, {
        dashboard_type: "Dealer SummaryDashboard",
      });
    } catch (err) {
      console.log(err.message);
    }
  };

  // AI Modal
  const handleAiModal = async (status) => {
    setShowAiChatBotModal(status);

    // Close floating menu when modal opens/closes
    if (!status) {
      setIsOpen(false);
    }

    try {
      await axInst.post(`user-logs`, {
        dashboard_type: "Dealer Chatbot",
      });
    } catch (error) {
      console.error("Error calling API:", error);
    }

    // Clear chatbot session on close
    if (!status) {
      try {
        await axInst2.post("/chatbot/clear-session");
      } catch (error) {
        console.error("Error clearing session:", error);
      }
    }
  };

  // Get chatbot status
  const getStatus = async () => {
    try {
      const res = await axInst.post("/dashboard_chatbot");
      setData(res.data.Status);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    getStatus();
  }, []);

  return (
    <>
      {/* Floating Container */}
      <div
        className="fixed bottom-6 right-6 flex flex-col items-center space-y-3 z-20"
        onMouseEnter={() => {
          // Hover only for desktop
          if (window.innerWidth > 768) {
            setIsOpen(true);
          }
        }}
        onMouseLeave={() => {
          // Hover close only for desktop
          if (window.innerWidth > 768) {
            setIsOpen(false);
          }
        }}
      >
        {/* Expandable Buttons */}
        {isOpen && (
          <div
            className="flex flex-col items-center space-y-3 mb-3
            transition-all duration-300
            animate-in fade-in slide-in-from-bottom-3"
          >
            {/* Summary Button */}
            <button
              title="Action Tracker"
              onClick={() => {
                handleModal(true);
                setIsOpen(false);
              }}
              className="group flex items-center justify-center
                w-[72px] h-[72px] rounded-2xl
                bg-gray-300 backdrop-blur-md
                border border-blue-200
                shadow-md
                hover:shadow-lg hover:scale-105
                active:scale-95 transition-all duration-300"
            >
              <img
                src={dealerSummaryImage}
                alt="Action Tracker"
                className="w-20 h-20 object-contain"
              />
            </button>

            {/* AI Bot Button */}
            {data === "True" && (
              <button
                title="CollabX AI Assistant"
                onClick={() => {
                  handleAiModal(true);
                  setIsOpen(false);
                }}
                className="group flex items-center justify-center
                  w-[72px] h-[72px] rounded-2xl
                  bg-gray-300 backdrop-blur-md
                  border border-purple-200
                  shadow-md
                  hover:shadow-lg hover:scale-105
                  active:scale-95 transition-all duration-300"
              >
                <img
                  src={chatBotImage}
                  alt="CollabX AI Assistant & More"
                  className="w-20 h-20 object-contain"
                />
              </button>
            )}
          </div>
        )}

        {/* Main Floating Button */}
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="relative group bg-[#5470c6] text-white p-5 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-visible"
        >
          <FaPlus
            size={20}
            className={`transition-transform duration-300 ${
              isOpen ? "rotate-45" : ""
            }`}
          />

          {/* Glow Effect */}
          <span
            className="absolute top-1/2 left-1/2 w-0 h-0 rounded-full
            bg-blue-500 opacity-40 transform
            -translate-x-1/2 -translate-y-1/2
            animate-radiate group-hover:animate-none
            pointer-events-none"
          ></span>
        </button>
      </div>

      {/* AI ChatBot Modal */}
      {showAiChatBotModal && data === "True" && (
        <AiChatBotModal handleModal={handleAiModal} />
      )}

      {/* Summary Modal */}
      {showSummaryModal && <SummaryModal handleModal={handleModal} />}
    </>
  );
};

export default FloatingButtonWithModal;
